import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  externalType() {
    const options = [
      'amazon_download',
      'amazon_physical',
      'amazon_unlimited',
      'barnes_noble',
      'deezer',
      'itunes',
      'jpc',
      'la_boite_a_musique',
      'mediamarkt_collection',
      'mediamarkt',
      'presto_digital',
      'presto_physical',
      'saturn_collection',
      'saturn',
      'spotify',
    ];

    return faker.helpers.arrayElement(options);
  },

  externalId() {
    return faker.random.alphaNumeric(5);
  },
});
